export default __webpack_public_path__ + "static/media/Valkyrie Zero.094ad743.png";